import React from 'react';
import { IAppHistorySearch, IAppHistoryCourse, IAppSearchData } from '@umu/umu-types';
import {
    SearchRange,
    IAppPopular,
    IAppLenovoElement,
    SearchInputForContentInputType,
} from '@umu/umu-search/src/searchInputForContent/common/interface';
import { FloatingLayerForContentBaseOfUmuNormal } from '@umu/umu-search/src/searchInputForContent/common/components/floatingLayerForContentBase/umu/normal/floatingLayerForContentBaseOfUmuNormal';
import { FloatingLayerForContentBaseOfUmuMicroPage } from '@umu/umu-search/src/searchInputForContent/common/components/floatingLayerForContentBase/umu/microPage/floatingLayerForContentBaseOfUmuMicroPage';
import { FloatingLayerForContentBaseOfUseMicroPage } from '@umu/umu-search/src/searchInputForContent/common/components/floatingLayerForContentBase/use/microPage/floatingLayerForContentBaseOfUseMicroPage';

type FloatingLayerForContentBaseProps = {
    inputType: string;

    // Common Input 参数
    keywords?: string;
    className?: string;
    panelType?: string;
    showType?: string;
    historySearch?: IAppHistorySearch[];
    popular?: IAppPopular[];
    historyCourse?: IAppHistoryCourse[];
    LenovoCourse?: IAppLenovoElement[];
    cleanCallback(): void;
    clickCallback(data: IAppSearchData, key: string): void;

    // MicroPage Input 参数
    isLogin?: boolean;
    isInIframe?: boolean;
    searchRange?: SearchRange;
    isEnterpriseAccount?: boolean;
    changeSearchRange?: (searchRange: SearchRange, keyword: string) => void;
};

function FloatingLayerForContentBase(props: FloatingLayerForContentBaseProps) {
    const { inputType, searchRange = SearchRange.currentPage } = props;

    const renderFloatingLayerForContentBase = (_inputType: string) => {
        switch (_inputType) {
            case SearchInputForContentInputType.umuCommon:
                return <FloatingLayerForContentBaseOfUmuNormal {...props} />;
            case SearchInputForContentInputType.umuMicroPage:
                return <FloatingLayerForContentBaseOfUmuMicroPage {...props} searchRange={searchRange} />;
            case SearchInputForContentInputType.useCommon:
                return <FloatingLayerForContentBaseOfUmuNormal {...props} />;
            case SearchInputForContentInputType.useMicroPage:
                return <FloatingLayerForContentBaseOfUseMicroPage {...props} searchRange={searchRange} />;
            default:
                return null;
        }
    };

    return <div className="umu-floating-layer-for-content-base">{renderFloatingLayerForContentBase(inputType)}</div>;
}

export default FloatingLayerForContentBase;
